import { render } from "./TicketsManager.vue?vue&type=template&id=00b55a3d&scoped=true"
import script from "./TicketsManager.vue?vue&type=script&lang=js"
export * from "./TicketsManager.vue?vue&type=script&lang=js"

import "./TicketsManager.vue?vue&type=style&index=0&id=00b55a3d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b55a3d"]])

export default __exports__